import { giphyCharcoal, giphyDarkCharcoal, giphyDarkGrey } from '@giphy/react-giphy-brand/src/css/colors'
import styled, { css } from 'styled-components'
import PresetComponent from '../../preset'
import { colorToRgba, heightFromControlSize } from 'utils'
import { SIDEBAR_COLOR, SIDEBAR_GAP, SIDEBAR_PRESET_SIZE } from '../../constants'

export const Preset = styled(PresetComponent)<{ $active: boolean }>`
    margin: 0 5px ${SIDEBAR_GAP}px;

    ${({ $active }) =>
        $active
            ? css`
                  background: ${giphyCharcoal};
              `
            : css`
                  background: ${giphyDarkGrey};
                  transition: background 0.1s ease-out;

                  &:hover {
                      background: ${giphyDarkCharcoal};
                  }
              `}
`

export const PresetsContainer = styled.div<{ $hasMore: boolean }>`
    max-height: 600px;
    overflow-y: auto;
    position: relative;

    ::-webkit-scrollbar {
        width: 12px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #4a4a4a;
        border-radius: 6px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }
    scrollbar-width: thin;
    scrollbar-color: #4a4a4a transparent;

    ${({ $hasMore }) => {
        const height = heightFromControlSize(SIDEBAR_PRESET_SIZE) + SIDEBAR_GAP * 2
        if ($hasMore) {
            return css`
                &:after {
                    content: '';
                    pointer-events: none;
                    width: 100%;
                    display: block;
                    height: ${height}px;
                    margin-top: ${-height}px;
                    position: relative;
                    background: linear-gradient(180deg, ${colorToRgba(SIDEBAR_COLOR, 0)} 0%, ${SIDEBAR_COLOR} 100%);
                }
            `
        }
    }}
`
